<template>
  <div class="page page-historia-geografia">
    <Header />
    <vue-headful
      title="Brincando Com História e Geografia | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
      description="Brincando Com História e Geografia | Ensino Fundamental - Anos Iniciais | Editora do Brasil"
    />
    <section class="banner">
      <b-container class="text-center">
        <div class="banner-img">
          <div class="banner-btn" align-content="center">
            <b-button
              href="https://editoradobrasil.com.br/faleconosco/"
              target="_blank"
            >DÚVIDAS? FALE CONOSCO</b-button>
          </div>
          <img
            class="img-fluid"
            alt
            src="../../assets/anos-iniciais/hist-e-geo/topo-historia-e-geografia.png"
          />
        </div>
      </b-container>
    </section>
    <section class="carousel text-center">
      <b-container class="carousel-container-text">
        <h2>Brincando Com<span class="d-block d-lg-none"> </span> História e Geografia<br>Ensino Fundamental</h2>
        <p>Aprender pode ser muito divertido com a nova edição do Brincando com História e Geografia!</p>
      </b-container>
      <b-container class="carousel-container-capas text-center">
        <div>
            <slick-carousel v-bind="settings">
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/historia-e-geografia/1/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-historia-e-geografia-1-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/historia-e-geografia/2/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-historia-e-geografia-2-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/historia-e-geografia/3/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-historia-e-geografia-3-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/historia-e-geografia/4/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-historia-e-geografia-4-la.jpg"
                    alt
                  />
                </a>
              </div>
              <div>
                <a
                  href="http://conteudos.editoradobrasil.com.br/flipbook/mercado/2021/degustacao/didatico/brincando-com/historia-e-geografia/5/index.html"
                  target="_blank"
                >
                  <img
                    src="https://conteudos.editoradobrasil.com.br/capa/mercado/2021/brincando-com-historia-e-geografia-5-la.jpg"
                    alt
                  />
                </a>
              </div>
            </slick-carousel>
          </div>
      </b-container>
    </section>
    <section class="destaques">
      <b-container>
        <h2 class="text-center">Destaques da coleção</h2>
        <ul>
          <li>Novo projeto gráfico;</li>
          <li>Contempla à BNCC;</li>
          <li>Material de fácil compreensão, intuitivo, lúdico e que busca proporcionar maior interação entre os alunos.</li>
          <li>Dados atualizados;</li>
          <li>Novas atividades e imagens;</li>
          <li>Traz atividades lúdicas que proporcionam ao aluno um ensino diferenciado;</li>
          <li>Manual do Professor em formato ‘’U’’ que permite fácil visualização de respostas e aprofundamentos, além de objetivos das unidades, orientações, atividades extras, sugestões de filmes, livros e sites e indicações de trabalho com a BNCC.</li>
        </ul>
      </b-container>
    </section>
  </div>
</template>

<script>
import Header from "../../components/Header.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "HistoriaGeografia",
  components: {
    Header,
    "slick-carousel": VueSlickCarousel
  },
  data: () => ({
    settings: {
      lazyLoad: "ondemand",
      arrows: true,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      touchThreshold: 3,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        },
        {
          breakpoint: 374,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false
          }
        }
      ]
    }
  }),
  props: {
    msg: String
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../../css/_colors.scss";
.page-historia-geografia {
  .menu {
    .menu-ef {
      background: $historia-geografia;
      > a {
        color: white !important;
      }
      span.menu-title::after {
        content: url("../../assets/material-keyboard-arrow-down-white.svg");
      }
    }
  }
  section.banner {
    background-color: $historia-geografia;
  }
  section.carousel {
    background: url("../../assets/ed-infantil/ed-infantil-bg-branco.png");
    background-repeat: no-repeat;
    background-position: top center;
    h2 {
      color: $historia-geografia;
    }
  }
  section.destaques {
    background: $historia-geografia-2
      url("../../assets/anos-iniciais/hist-e-geo/fundo-destaques.png");
    background-repeat: no-repeat;
    background-position: top center;
    color: white !important;
  }
}
</style>
